import { OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatDialogRef } from '@angular/material';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var NotificationDialogComponent = /** @class */ (function () {
    function NotificationDialogComponent(dialogRef, data, mediaChange) {
        this.dialogRef = dialogRef;
        this.mediaChange = mediaChange;
        this._subrelease = new Subject();
        this.AllBoardHeaders = ['AsDesignee', 'RequestIssueNumber', 'Subject', 'RequestStatus', 'Actions'];
        this.AllNonBoardHeaders = ['AsDesignee', 'RequestIssueNumber', 'BoardMember', 'Subject', 'DateReferred', 'RequestStatus', 'Actions'];
        this.TitleText = data.TitleText || 'Notification Details...';
        this.MessageText = data.MessageText || '';
        this.Details = data.Details || [];
        this.HasDesigneeEntries = this.Details.findIndex(function (r) { return r.AsDesignee === true; }) >= 0;
        this.AsBoard = data.AsBoard || false;
    }
    NotificationDialogComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    NotificationDialogComponent.prototype.ngOnInit = function () {
        var self = this;
        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
                ? 'sm'
                : self.mediaChange.isActive('md')
                    ? 'md'
                    : self.mediaChange.isActive('lg')
                        ? 'lg'
                        : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AsBoard ? self.AllBoardHeaders : self.AllNonBoardHeaders;
        if (!self.HasDesigneeEntries) {
            self.VisibleHeaders = self.VisibleHeaders.filter(function (h) { return h !== 'AsDesignee'; });
        }
        self.VisibleColumns = self.VisibleHeaders.slice();
        self.mediaChange.media$.pipe(takeUntil(self._subrelease)).subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AsBoard ? self.AllBoardHeaders : self.AllNonBoardHeaders;
            if (!self.HasDesigneeEntries) {
                self.VisibleHeaders = self.VisibleHeaders.filter(function (h) { return h !== 'AsDesignee'; });
            }
            self.VisibleColumns = self.VisibleHeaders.slice();
        });
        this.DetailsData = new MatTableDataSource(self.Details);
    };
    // #region OK Handler
    NotificationDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close(null);
    };
    // #endregion
    // #region View Referral Method
    NotificationDialogComponent.prototype.ViewReferral = function (referral) {
        this.dialogRef.close(referral);
    };
    return NotificationDialogComponent;
}());
export { NotificationDialogComponent };
// #region Custom Classes
// #region Base Notification Dialog Options Class
var BaseNotificationDialogOptions = /** @class */ (function () {
    function BaseNotificationDialogOptions() {
    }
    return BaseNotificationDialogOptions;
}());
export { BaseNotificationDialogOptions };
// #endregion
// #endregion
